module.exports = __webpack_public_path__ + "img/US_RangeDPS_ua.e64d20d6.webp";